import _defineProperty from "/codebuild/output/src2317851137/src/gatsby-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../types.js').Handle} Handle
 * @typedef {import('../types.js').Exit} Exit
 * @typedef {import('../util/indent-lines.js').Map} Map
 */
import { longestStreak } from 'longest-streak';
import { formatCodeAsIndented } from '../util/format-code-as-indented.js';
import { checkFence } from '../util/check-fence.js';
import { indentLines } from '../util/indent-lines.js';
import { safe } from '../util/safe.js';
import { track } from '../util/track.js';
/**
 * @type {Handle}
 * @param {Code} node
 */

export function code(node, _, context, safeOptions) {
  var marker = checkFence(context);
  var raw = node.value || '';
  var suffix = marker === '`' ? 'GraveAccent' : 'Tilde';

  if (formatCodeAsIndented(node, context)) {
    var _exit = context.enter('codeIndented');

    var _value = indentLines(raw, map);

    _exit();

    return _value;
  }

  var tracker = track(safeOptions);
  var sequence = marker.repeat(Math.max(longestStreak(raw, marker) + 1, 3));
  var exit = context.enter('codeFenced');
  var value = tracker.move(sequence);

  if (node.lang) {
    var subexit = context.enter('codeFencedLang' + suffix);
    value += tracker.move(safe(context, node.lang, _objectSpread({
      before: value,
      after: ' ',
      encode: ['`']
    }, tracker.current())));
    subexit();
  }

  if (node.lang && node.meta) {
    var _subexit = context.enter('codeFencedMeta' + suffix);

    value += tracker.move(' ');
    value += tracker.move(safe(context, node.meta, _objectSpread({
      before: value,
      after: '\n',
      encode: ['`']
    }, tracker.current())));

    _subexit();
  }

  value += tracker.move('\n');

  if (raw) {
    value += tracker.move(raw + '\n');
  }

  value += tracker.move(sequence);
  exit();
  return value;
}
/** @type {Map} */

function map(line, _, blank) {
  return (blank ? '' : '    ') + line;
}